import styled from "styled-components";
import { device } from "../../utils/helpers/breakpoints";

export const MessageContainer = styled.div`
  display: flex;
  height: 100vh;
  position: relative;
  & > aside {
    width: 18.75rem;
    top: 0;
    height: 100vh;
    @media ${device.tablet} {
      position: fixed !important;
      width: 5rem;
    }
  }

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow-y: auto;
    padding: 1rem;
    margin-left: 1rem;
    @media ${device.tablet} {
      margin-left: 5rem;
    }
  }
`;

export const MessageNavContainer = styled.div`
  display: flex;
  align-item: center;
  height: 5rem;
`;

export const MessageNav = styled.div`
  display: flex;
  padding: 1rem;
  align-items: center;
  height: 5rem;
  font-weight: 600;
  font-size: 1.2rem;
  // border-bottom: 1px solid grey;
  & img {
    border-radius: 50%;
    border: 1px solid grey;
    width: 3rem;
    height: 3rem;
    margin-right: 1rem;
  }
`;

export const MessageContent = styled.div`
  padding: 0rem 1rem;
  margin-top: 1rem;
  max-height: 75vh;
  overflow: auto;
  @media ${device.tablet} {
    margin-top: 0rem;
    max-height: 75vh;
    padding: 0rem 0rem;
  }
`;

export const MessageFooter = styled.div`
  position: absolute;
  bottom: 0;
  margin-bottom: 1rem;
  width: 100%;
  @media ${device.tablet} {
    margin-bottom: 3rem;
  }
`;

export const SendMessageContainer = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-radius: 8px;

  button {
    width: 36px;
    height: 36px;
    background-color: #daf5df;
    border: none;
    box-shadow: none;
    outline: none;
    cursor: pointer;
    font-size: 16px;
    color: #1a5304;
    padding: 0 8px;
    border-radius: 5px;
    line-height: 36px;
    transition: all 0.3s cubic-bezier(0.88, 0.19, 0.37, 1.77);
    &: hover {
      transform: scale(1.2);
    }
    i {
      display: block;
    }
  }

  input {
    flex-grow: 1;
    padding: 0 15px;
    background-color: transparent;
    border: none;
    outline: none;
  }
`;

export const SendMsgButton = styled.button`
  background-color: #3b5bfe;
  color: #fff;
`;
